// istanbul ignore file

import { Stage, stageFromString } from '@eventbrite/webapp-constants';

import { resolveBackendStage } from '@/lib/backend-stage';

const getStageEnv = () => {
    if (process.env.STAGE) {
        return process.env.STAGE;
    }
    if (process.env.NODE_ENV === 'development') {
        console.warn('No STAGE environment variable found, using TEST');
    }
    return Stage.TEST;
};

export function getStage() {
    return stageFromString(getStageEnv());
}

export function getBackendStage(): Stage {
    const backendStage = resolveBackendStage(getStage());
    return backendStage === Stage.PROD ? Stage.PROD : Stage.TEST;
}
